import { useEffect, useState } from "react";
import { ReadsLogo } from "./ReadsLogo";

/**
 * First-visit splash screen. Shows the R mark on a cream background for
 * ~900ms, then fades out. Uses `sessionStorage` so it only fires once per
 * tab session (not on every route change or refresh spam).
 *
 * Matches the app's launch screen for visual continuity between web + PWA.
 */
export function SplashScreen() {
  const [visible, setVisible] = useState(() => {
    try {
      return typeof window !== "undefined" && !sessionStorage.getItem("readsSplashShown");
    } catch {
      return false;
    }
  });
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (!visible) return;
    const t1 = setTimeout(() => setFading(true), 700);
    const t2 = setTimeout(() => {
      setVisible(false);
      try { sessionStorage.setItem("readsSplashShown", "1"); } catch { /* noop */ }
    }, 1100);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-[#F0EAD6] transition-opacity duration-[400ms] ease-out ${fading ? "opacity-0 pointer-events-none" : "opacity-100"}`}
      data-testid="splash-screen"
      aria-hidden={fading}
    >
      <div className="flex flex-col items-center animate-in fade-in duration-[500ms]">
        <div
          style={{
            fontFamily: "'Playfair Display','DM Serif Display', Georgia, serif",
            fontWeight: 800,
            fontSize: "128px",
            lineHeight: 1,
            color: "#0A0A0A",
            letterSpacing: "-0.04em",
          }}
          className="splash-r"
        >
          R
        </div>
        <div className="mt-8 font-mono uppercase tracking-[0.4em] text-[10px] text-[#4A4030]">Reads</div>
      </div>
      <style>{`
        @keyframes splash-fade-in { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }
        .splash-r { animation: splash-fade-in 500ms ease-out both; }
      `}</style>
    </div>
  );
}
